import { UsersList } from '../Model/userObjects';

export const USERS_LIST = 'USERS_LIST';

const initialState = new UsersList();

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case USERS_LIST:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "users";

const storeMapping = {[storeName]: reducer};

export const usersSelector = (state) => state[storeName];

export default storeMapping;
